import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getBookingHistory } from './api';

export const BOOKING_HISTORY = 'bookingHistory';

export function useBookingHistory({ from, to, resourceType } = {}) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [BOOKING_HISTORY, tenantId, from, to, resourceType],
    () => getBookingHistory({ from, to, resourceType }),
    {
      enabled: Boolean(from && to),
    },
  );

  return {
    bookingHistory: Array.isArray(data) ? data : data?.bookings || [],
    isLoading,
    isFetching,
    isError,
  };
}
